exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:300,400,500,700,900);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Overpass+Mono:400,700);", ""]);

// module
exports.push([module.id, "body{background-color:#fafafa}#app{max-width:780px;margin:auto;font-family:Roboto,sans-serif;color:#2c3e50}input{margin:12px 0;font-family:inherit;font-size:inherit;padding:8px 16px;border:none;border-bottom:2px solid #4fc08d;outline:none;margin-right:24px}hr{border:none;border-bottom:2px solid #ddd}h1{font-size:48px;margin:48px 0 8px;font-weight:900}h3{margin:0 0 24px;font-weight:300}h4{margin:36px 0 12px}span{opacity:.5;margin-left:16px;white-space:nowrap}.code{padding:24px;font-family:Overpass Mono,monospace;background-color:#eee;font-size:.95em;font-weight:500;line-height:1.5em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5866d4c4","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 304
// module chunks = 0